/**
 * @description
 * Here you can define all menu items from main sidebar menu
 * @see RouteInfo interface for all posible item configurations
 */
export const NAVBAR_ROUTES: any[] = [
  {
    path: '/request-payments',
    title: 'Početna',
  },
  {
    path: '/payments',
    title: 'Moje transakcije',
  },
  {
    path: '/support',
    title: 'Podrška',
  },
];
